export const LOCALES = {
  en: { code: "en", label: "English" },
  ja: { code: "ja", label: "日本語" },
};

export const translations = {
  en: {
    nav: {
      coupons: "Coupons",
      packages: "Packages",
      recommended: "Recommended",
      contact: "Contact",
      bookNow: "BOOK NOW",
      logIn: "Log In",
      language: "Language",
    },
    home: {
      packages: "Our Packages",
      title: "Search your holiday",
      destLabel: "Search your destination",
      destPlaceholder: "enter name here.",
      noMatch: "No matching destinations",
      dateLabel: "Select your date:",
      datePlaceholder: "Pick a date",
      prevMonth: "Previous month",
      nextMonth: "Next month",
      maxPrice: "Max price:",
      moreFilters: "MORE FILTERS",
      showLess: "SHOW LESS",
      rooms: "Rooms",
      adults: "Adults",
      children: "Children",
      confirm: "Confirm",
      weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    },
    coupons: {
      eyebrow: "Limited offers",
      title: "Sign up to get Limited Coupons",
      claim: "Claim",
      prev: "Previous coupons",
      next: "Next coupons",
      items: [
        {
          title: "Sign up for 10% off",
          detail: "New members unlock limited coupons instantly.",
        },
        {
          title: "Mongolia is on this season",
          detail: "Steppe skies and ger stays—book while the deal lasts.",
        },
        {
          title: "Hotel perk up to $100 off",
          detail: "Stay longer, save more on selected partners.",
        },
        {
          title: "Weekend escape boost",
          detail: "Extra credit when you reserve within 48 hours.",
        },
        {
          title: "Family pack surprise",
          detail: "Kids’ add-ons discounted on select destinations.",
        },
        {
          title: "Early-bird flights −15%",
          detail: "Depart before peak season and lock in lower fares.",
        },
        {
          title: "City walk + museum pass",
          detail: "Bundle culture days in partner cities this month.",
        },
      ],
    },
    main: {
      title: "Most visited destinations",
      reviews: "reviews",
      details: "DETAILS",
      addFavorite: "Add favorite",
      removeFavorite: "Remove favorite",
    },
    hashtags: {
      eyebrow: "Site picks",
      title: "Recommended Destination",
      intro:
        "Tap a tag to keep the destinations in mind—real places, ready when you are.",
    },
    footer: {
      keepInTouch: "KEEP IN TOUCH",
      travelWithUs: "Travel with us",
      emailPlaceholder: "Enter Email Address",
      send: "Send",
      blurb:
        "From trip planning to local experiences. We support your kind of holiday at a comfortable pace.",
      agency: "OUR AGENCY",
      partners: "PARTNERS",
      lastMinute: "LAST MINUTE",
      agencyLinks: ["Services", "Insurance", "Agency", "Tourism", "Payment"],
      partnerLinks: [
        "Bookings",
        "Rentcars",
        "HostelWorld",
        "Trivago",
        "Tripadvisor",
      ],
      lastMinuteLinks: [
        "London",
        "California",
        "Indonesia",
        "Europe",
        "Oceania",
      ],
      rights: "@2024 Yimajiuni ALL RIGHTS RESERVED.",
    },
    destinations: {
      1: {
        destTitle: "Bora Bora",
        country: "French Polynesia",
        location: "Bora Bora Lagoon",
        grade: "Cultural Relax",
        description:
          "The epitome of romance—Bora Bora is known for luxurious stays and lagoon adventures that feel real, not staged.",
      },
      2: {
        destTitle: "Machu Picchu",
        country: "Peru",
        location: "Cusco Region",
        grade: "Cultural Trek",
        description:
          "Huayna Picchu rises over the Lost City of the Incas. Sunrise from the Sun Gate is simply spectacular.",
      },
      3: {
        destTitle: "Great Barrier Reef",
        country: "Australia",
        location: "Queensland",
        grade: "Ocean Escape",
        description:
          "One of Australia’s remarkable natural gifts—lavish color underwater and quiet beaches above.",
      },
      4: {
        destTitle: "Cappadocia",
        country: "Turkey",
        location: "Göreme",
        grade: "Cultural Relax",
        description:
          "Balloon mornings and carved valleys. About 2 million of Turkey’s visitors come for Cappadocia each year.",
      },
      5: {
        destTitle: "Guanajuato",
        country: "Mexico",
        location: "Central Highlands",
        grade: "City Color",
        description:
          "Silver-mining history and colonial streets painted in the brightest colors you can find.",
      },
      6: {
        destTitle: "Cinque Terre",
        country: "Italy",
        location: "Liguria",
        grade: "Coastal Walk",
        description:
          "Cliffside villages in vibrant hues—and seafood that makes every evening feel like a discovery.",
      },
      7: {
        destTitle: "Angkor Wat",
        country: "Cambodia",
        location: "Siem Reap",
        grade: "Heritage",
        description:
          "Khmer art from the 9th to 15th century—the heart and soul of Cambodia at golden hour.",
      },
      8: {
        destTitle: "Taj Mahal",
        country: "India",
        location: "Agra",
        grade: "Iconic Visit",
        description:
          "White marble built for Mumtaz—breathtaking at dawn, still quietly moving at dusk.",
      },
      9: {
        destTitle: "Bali Island",
        country: "Indonesia",
        location: "Ubud & Beaches",
        grade: "Island Soul",
        description:
          "Volcanoes, temples, food, and sandy beaches—holiday energy with a real island pace.",
      },
    },
  },
  ja: {
    nav: {
      coupons: "クーポン",
      packages: "パッケージ",
      recommended: "おすすめ",
      contact: "お問い合わせ",
      bookNow: "今すぐ予約",
      logIn: "ログイン",
      language: "言語",
    },
    home: {
      packages: "パッケージ一覧",
      title: "休日を検索する",
      destLabel: "行き先を検索",
      destPlaceholder: "地名を入力",
      noMatch: "一致する行き先がありません",
      dateLabel: "日付を選択：",
      datePlaceholder: "日付を選ぶ",
      prevMonth: "前の月",
      nextMonth: "次の月",
      maxPrice: "上限価格：",
      moreFilters: "詳細フィルター",
      showLess: "閉じる",
      rooms: "部屋数",
      adults: "大人",
      children: "子ども",
      confirm: "確定",
      weekdays: ["日", "月", "火", "水", "木", "金", "土"],
    },
    coupons: {
      eyebrow: "期間限定",
      title: "会員登録で限定クーポン",
      claim: "利用する",
      prev: "前のクーポン",
      next: "次のクーポン",
      items: [
        {
          title: "新規登録で10% off",
          detail: "会員登録ですぐに限定クーポンを受け取れます。",
        },
        {
          title: "今季はモンゴルへ",
          detail: "草原の空とゲルステイ。お得なうちにご予約を。",
        },
        {
          title: "ホテル特典 最大$100 off",
          detail: "対象パートナーで長く泊まるほどお得に。",
        },
        {
          title: "週末 Escape ブースト",
          detail: "48時間以内の予約で追加クレジット。",
        },
        {
          title: "ファミリーパック特典",
          detail: "対象行き先で子どもオプションが割引。",
        },
        {
          title: "早割フライト −15%",
          detail: "ピーク前の出発でお得な運賃を確保。",
        },
        {
          title: "街歩き＋美術館パス",
          detail: "提携都市の文化デーを今月まとめて。",
        },
      ],
    },
    main: {
      title: "人気の行き先",
      reviews: "件のレビュー",
      details: "詳細",
      addFavorite: "お気に入りに追加",
      removeFavorite: "お気に入りから削除",
    },
    hashtags: {
      eyebrow: "サイトセレクト",
      title: "おすすめの行き先",
      intro:
        "タグをタップして行き先をメモ。いつでも出かけられる実在の場所です。",
    },
    footer: {
      keepInTouch: "最新情報をお届け",
      travelWithUs: "いっしょに旅しよう",
      emailPlaceholder: "メールアドレスを入力",
      send: "送信",
      blurb:
        "旅の計画から現地体験まで。あなたらしい休日を、心地よいペースでサポートします。",
      agency: "当社について",
      partners: "パートナー",
      lastMinute: "直前オファー",
      agencyLinks: ["サービス", "保険", "代理店", "ツーリズム", "お支払い"],
      partnerLinks: [
        "Bookings",
        "Rentcars",
        "HostelWorld",
        "Trivago",
        "Tripadvisor",
      ],
      lastMinuteLinks: [
        "ロンドン",
        "カリフォルニア",
        "インドネシア",
        "ヨーロッパ",
        "オセアニア",
      ],
      rights: "@2024 Yimajiuni ALL RIGHTS RESERVED.",
    },
    destinations: {
      1: {
        destTitle: "ボラボラ",
        country: "フランス領ポリネシア",
        location: "ボラボラ・ラグーン",
        grade: "文化・リラックス",
        description:
          "ロマンチックな島の象徴。ラグーンと上質な滞在が、飾らない本物の時間をつくります。",
      },
      2: {
        destTitle: "マチュ・ピチュ",
        country: "ペルー",
        location: "クスコ地方",
        grade: "文化・トレッキング",
        description:
          "インカの失われた都を望むワイナ・ピチュ。サン・ゲートからの日の出は圧巻です。",
      },
      3: {
        destTitle: "グレートバリアリーフ",
        country: "オーストラリア",
        location: "クイーンズランド",
        grade: "オーシャンエスケープ",
        description:
          "オーストラリアの自然の贈り物。海中の色と、静かなビーチが待っています。",
      },
      4: {
        destTitle: "カッパドキア",
        country: "トルコ",
        location: "ギョレメ",
        grade: "文化・リラックス",
        description:
          "気球の朝と切り立った渓谷。トルコを訪れる人の多くがカッパドキアへ向かいます。",
      },
      5: {
        destTitle: "グアナファト",
        country: "メキシコ",
        location: "中央高地",
        grade: "シティカラー",
        description:
          "銀鉱山の歴史と、鮮やかな色に塗られたコロニアルな街並み。",
      },
      6: {
        destTitle: "チンクエ・テッレ",
        country: "イタリア",
        location: "リグーリア",
        grade: "海岸ウォーク",
        description:
          "断崖の色とりどりの村と、毎晩が発見になるシーフード。",
      },
      7: {
        destTitle: "アンコール・ワット",
        country: "カンボジア",
        location: "シェムリアップ",
        grade: "ヘリテージ",
        description:
          "9〜15世紀のクメール美術。黄金の時間に感じるカンボジアの心。",
      },
      8: {
        destTitle: "タージ・マハル",
        country: "インド",
        location: "アーグラ",
        grade: "アイコニック",
        description:
          "ムムターズのために建つ白い大理石。夜明けは息をのみ、夕暮れも静かに心を動かします。",
      },
      9: {
        destTitle: "バリ島",
        country: "インドネシア",
        location: "ウブド＆ビーチ",
        grade: "アイランドソウル",
        description:
          "火山、寺院、食、砂浜。島のペースで味わう休日のエネルギー。",
      },
    },
  },
};
